import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Content, SubContent, Main } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import ModalQuestion from "../../../components/Modal/modal-survey-question";
import ModalAnswer from "../../../components/Modal/modal-survey-answer";
import getSurvey from "../../../util/getSurvey";
import Pagenation from "../../../components/Pagenation";
import StatusFlag from "../../../components/StatusFlag";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import TableResponsive from "../../../components/TableResponsive";
import useFormat from "../../../hooks/utils/useFormat";
import Button from "../../../components/Button";

export default function Graduate() {
  const { setbreadcrumb, config } = useWrapper();
  const { formatQuery, formatDate } = useFormat();

  const { commercial } = useOutletContext();
  const { commercialId } = useParams();

  const [isWaitingResponse, setisWaitingResponse] = useState(true);

  useEffect(() => {
    applyFilter(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional mount-only fetch. `applyFilter` is redefined every render (it closes over unmemoized `config` from context), so adding it as a dep would refire this on every render instead of once on mount.
  }, []);

  const [survey, setsurvey] = useState();
  const filter_init = {};
  const [filter, setfilter] = useState(filter_init);

  const applyFilter = async (__filter, __setPreset) => {
    try {
      setisWaitingResponse(true);
      const _filter = __filter || filter;
      if (!!__filter) {
        setfilter(__filter);
      }
      const _query = `?${formatQuery({
        ..._filter,
        commercial_id: commercialId,
      })}`;

      const _survey = await getSurvey({
        query: _query,
        config,
      });
      setsurvey(_survey);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar as enquetes.");
    } finally {
      setisWaitingResponse(false);
    }
  };

  const [modal, setmodal] = useState();

  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial, setbreadcrumb]);

  return (
    <>
      <Main>
        <Content noBG="true">
          <Row>
            <Col>
              <SubContent>
                <Row>
                  <Col sm={9}>
                    <h2 className="mini-title">Gerenciar Enquetes:</h2>
                    <p className="small-label mb-4">
                      Elabore enquetes para os formandos votarem. Personalize perguntas e opções para coletar
                      informações.
                    </p>
                  </Col>
                  <Col sm={3} className="text-end">
                    <Button
                      color="primary"
                      onClick={() => {
                        setmodal({
                          type: "new_survey",
                        });
                      }}
                    >
                      Nova Enquete
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {!isWaitingResponse ? (
                      <>
                        <TableResponsive
                          table={{
                            head: [
                              { data: "ID" },
                              { data: "Pergunta" },
                              { data: "Principal Resposta" },
                              { data: "Respostas" },
                              { data: "Autoria" },
                              { data: "Encerramento" },
                              { data: "Status" },
                            ],

                            body: survey?.data?.map(__question => {
                              return {
                                onClick: () => {
                                  setmodal({
                                    type: "view_survey",
                                    survey_id: __question.id,
                                  });
                                },
                                data: [
                                  {
                                    element: <span>{__question.id}</span>,
                                  },
                                  {
                                    element: <span>{__question.description}</span>,
                                  },
                                  {
                                    element: (
                                      <>
                                        <span>
                                          {!!__question?.surveyOptions?.[0] && (
                                            <>
                                              <span>{__question?.surveyOptions?.[0]?.quest || "-"}</span>
                                              <span className="op-5">
                                                {" "}
                                                ({parseFloat(__question.surveyOptions[0].votes_percent?.toFixed(2))}%)
                                              </span>
                                            </>
                                          )}
                                        </span>
                                      </>
                                    ),
                                  },
                                  {
                                    element: <span>{__question.surveyAnswer.length}</span>,
                                  },
                                  {
                                    element: (
                                      <span>
                                        {__question?.users?.username || __question?.trainees?.name || "?"}
                                        <span className="op-5">{!!__question.users ? " (Gestor)" : " (Comissão)"}</span>
                                      </span>
                                    ),
                                  },
                                  { element: formatDate(__question?.expires_date, 2) },
                                  {
                                    element: <StatusFlag status={__question.status} />,
                                  },
                                ],
                              };
                            }),
                          }}
                        />
                        <Pagenation
                          current={survey?.page}
                          total={survey?.lastPage}
                          pageChange={__page => {
                            applyFilter({
                              ...filter,
                              page: __page,
                            });
                          }}
                          className="mt-4"
                        />
                      </>
                    ) : (
                      <Loading />
                    )}
                  </Col>
                </Row>
              </SubContent>
            </Col>
          </Row>
        </Content>
      </Main>
      <ModalQuestion
        show={modal?.type === "new_survey"}
        onHide={() => {
          setmodal();
        }}
        refreshCallback={() => {
          applyFilter();
        }}
        commercial_id={commercialId}
      />
      <ModalAnswer
        show={modal?.type === "view_survey"}
        onHide={() => {
          setmodal();
        }}
        survey_id={modal?.survey_id}
        refreshCallback={() => {
          applyFilter();
        }}
      />
    </>
  );
}
